import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Notification } from "../notification";
import { NotificationActions } from "../state/actions";

@Injectable({
  providedIn: "root"
})
export class NotificationFacade {
  constructor(private store: Store) {}

  public default(content: string, hideAfter?: number): void {
    this.show({ content, hideAfter, level: "none" });
  }

  public showError(content: string, hideAfter?: number): void {
    this.show({ content, hideAfter, level: "error" });
  }

  public info(content: string, hideAfter?: number): void {
    this.show({ content, hideAfter, level: "info" });
  }

  private show(notification: Notification): void {
    this.store.dispatch(NotificationActions.showNotification({ notification }));
  }

  public success(content: string, hideAfter?: number): void {
    this.show({ content, hideAfter, level: "success" });
  }

  public warning(content: string, hideAfter?: number): void {
    this.show({ content, hideAfter, level: "warning" });
  }
}
